import HomePage from "./HomePage.jsx"
import NotFoundPage from "./NotFoundPage"

// Register all site page routes at once using an object
export default {
  "/": HomePage,
  "/404": NotFoundPage,
}